<template>
	<div class="banner">

		<div class="banner__bg-wrapper">
			<div class="banner__bg" v-bind:style="{ backgroundImage: `url('${mqBackgroundImage}')` }">
			</div>
		</div>

		<div class="banner__centraliser">
			<div class="banner__content">
				<slot />
			</div>
		</div>

	</div>
</template>


<script>

export default {
	name: 'Banner',
	components: {
	},
	data () {
		return {
		}
	},
	props: {
		backgrounds: [String, Object],
	},
	computed: {
		mqBackgroundImage: function()
		{
			var self = this;

			//If we have a string...
			if(typeof self.backgrounds === 'string') { return self.backgrounds; }

			//Otherwise, it's an object...
			return self.backgrounds && self.backgrounds.hasOwnProperty(self.$mq) ? self.backgrounds[self.$mq] : '';
		},
	},
	created: function()
	{
	},
	mounted: function()
	{
		// console.log(this.heroBackground)
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	/*
	 * Screen filling container
	 */

	$c: ".banner";
	#{$c}
	{
		@include extend(vertical-center);
		position: relative;
		z-index: 0;						// Create a z-index context
		@include extend(bgc-pal--black);
		padding-top: rem(20);
		padding-bottom: rem(20);



		// Modifiers ------



		// Children ------

		&__bg-wrapper
		{
			@include extend(absolute-fill);
		}

		&__bg
		{
			@include extend(absolute-fill);
			@include extend(bg-fill);
			background-position: center center;

			// AR = 1080 / 1920
		}

		&__video
		{
			@include extend(hide--port);
		}

		&__content {
			width: 100%;
		}

		&__centraliser
		{
			position: relative;
			z-index: 10;
			flex: auto 0 0;		// IE fix
			@include extend(page-container);

			// // Leave spacing for a scroll hint
			// #{$c}--hint-space &
			// {
			// 	@include media(not-mob)
			// 	{
			// 		padding-bottom: 20px + 60px;
			// 	}
			// }

			// #{$c}--hint-space--mob &
			// {
			// 	@include media(mob)
			// 	{
			// 		padding-bottom: 20px + 45px;
			// 	}
			// }

			img
			{
				width: auto !important;
				height: auto !important;
				pointer-events: auto;
			}
		}



		// Project specific ------------------------

	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/Banner.vue